"use client";

import React, { useState, useEffect } from "react";
import DismissibleBadge from "../badge/DismissibleBadge";
import { useTranslations } from "next-intl";
import { useRouter } from "next/navigation";

function AgesFilter({ onChange }: { onChange: (value: number[]) => void }) {
  const [selectedFilters, setFilters] = useState<number[][]>([[0, 100]]);
  const sortedAges = selectedFilters.flat(1).sort((a, b) => a - b);
  const { push } = useRouter();

  useEffect(() => {
    onChange(sortedAges);
  }, [selectedFilters]);
  const toggleSelected = (selected: Filter) => {
    push("#agesFilter");

    const selectedIsExisting =
      selectedFilters.findIndex(
        (item) => item[0] == selected.min && item[1] == selected.max
      ) >= 0;
    if (selectedIsExisting) {
      const filleted = selectedFilters.filter(
        (item) => !(item[0] == selected.min && item[1] == selected.max)
      );
      if (filleted.length == 0) {
        setFilters([[0, 100]]);
        return;
      }
      setFilters(filleted);

      return;
    }
    if (selected.max == 100) {
      setFilters([[selected.min, selected.max]]);
      return;
    }
    if (selected.max !== 100) {
      const filleted = selectedFilters.filter((item) => !(item[1] == 100));
      setFilters([...filleted, [selected.min, selected.max]]);
      return;
    }

    setFilters((prev) => [...prev, [selected.min, selected.max]]);
  };
  const t = useTranslations("Index");
  const filters: Filter[] = [
    {
      key: t("allAges"),
      min: 0,
      max: 100,

      color: "#52A8F2",
    },
    {
      key: " 7-9",
      min: 7,
      max: 9,
      color: "#F26716",
    },
    {
      key: "10-13",
      min: 10,
      max: 13,
      color: "#2BD988",
    },
    {
      key: "14-17",
      min: 14,
      max: 17,
      color: "#F2A20C",
    },
  ];
  return (
    <div className="flex justify-center overflow-x-auto gap-10 lg:gap-[8.12rem] py-20 scroll">
      {filters.map((filter) => (
        <DismissibleBadge
          key={filter.key}
          color={filter.color}
          className="flex-shrink-0"
          open={
            selectedFilters.findIndex(
              (item) => item[0] == filter.min && item[1] == filter.max
            ) >= 0
          }
          toggleOpen={() => toggleSelected(filter)}
        >
          {filter.key}
        </DismissibleBadge>
      ))}
    </div>
  );
}
type Filter = {
  key: string;
  color: string;
  min: number;
  max: number;
};

export default AgesFilter;
